var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper ml-20"},[_c('vc-header',{attrs:{"iconName":_vm.name,"displayName":_vm.$t('dashboard.dashboard'),"email":_vm.getUserEmail}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }